/* src/app/core/containers/app/app.component.scss */
:host {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (min-width: 1176px) {
  .logout {
    display: none;
  }
}
/*# sourceMappingURL=app.component.css.map */
